import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const CreditCardColorful = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size), ...props.style }}
    viewBox="0 0 104 80"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Atom/artwork/credit-card</title>
    <g
      id="On-boarding"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="how-it-works-step-2---8pt-copy"
        transform="translate(-136.000000, -304.000000)"
      >
        <g
          id="Organism/widget/onboarding/step-2"
          transform="translate(32.000000, 184.000000)"
        >
          <g
            id="Atom/artwork/credit-card"
            transform="translate(104.000000, 120.000000)"
          >
            <path
              d="M95.032126,0 L8.64388602,0 C3.87055428,0 0,3.98220489 0,8.89322933 L0,17.7777778 L103.676012,17.7777778 L103.676012,8.89322933 C103.676012,3.98220489 99.8054582,0 95.032126,0 Z"
              id="Path"
              fill="#1EA6D1"
            ></path>
            <path
              d="M0,71.124132 C0,76.0264756 3.86211722,80 8.62701189,80 L95.050055,80 C99.8138952,80 103.676012,76.0264756 103.676012,71.124132 L103.676012,35.5555556 L0,35.5555556 L0,71.124132 Z"
              id="Path"
              fill="#1EA6D1"
            ></path>
            <ellipse
              id="Oval"
              fill="#FFFFFF"
              cx="41.0384216"
              cy="57.7777778"
              rx="6.47975078"
              ry="6.66666667"
            ></ellipse>
            <ellipse
              id="Oval"
              fill="#FFFFFF"
              cx="19.4392523"
              cy="57.7777778"
              rx="6.47975078"
              ry="6.66666667"
            ></ellipse>
            <rect
              id="Rectangle"
              fill="#505050"
              x="0"
              y="17.7777778"
              width="103.676012"
              height="17.7777778"
            ></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
